import React, { Component } from "react";
import { Isvg } from "../../../../components";
import PropTypes from "prop-types";
import CardInput from "./card-input";
import { BookStore, Dispatcher } from "../../../../flux";
import { cardContentPropTypes, getEmptyCard } from "../../types";
import { TYPE_IMAGE } from "../../../../../../stores/overleaf-store";
import { Button } from "@vitalsource/vstui";
import { areFlashcardFiguresEnabled } from "../../utils";

class TemplatePresentation extends Component {
  state = {
    figurePickerOpen: false,
    figureForFront: false,
    figures: []
  };

  componentDidMount() {
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 1);
    Dispatcher.bind(Dispatcher.BOOK_FIGURES_LOADED, this.getFigures);
    this.getFigures(); // call this in case figures load when not mounted
  }

  componentWillUnmount() {
    Dispatcher.removeListener(Dispatcher.BOOK_FIGURES_LOADED, this.getFigures);
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() - 1);
  }

  getFigures = () => {
    const book = BookStore.get(this.props.isbn);
    const figures = book.getFigures();
    if (figures && figures.length > 0) {
      this.setState({ figures });
    }
  };

  openFiguresFront = () => {
    this.figureForFront = true;
    this.openFigures();
  };

  openFiguresBack = () => {
    this.figureForFront = false;
    this.openFigures();
  };

  openFigures() {
    Dispatcher.emit(Dispatcher.OPEN_MODAL, "flashcard-figure-picker", {
      isOpen: true,
      figures: this.state.figures,
      onRequestClose: this.closeFigures,
      rootSelector: "#bookshelf",
      onAdd: this.addFigure,
      isbn: this.props.isbn
    });
  }

  closeFigures = () => {
    Dispatcher.emit(Dispatcher.CLOSE_MODAL);
  };

  addFigure = figureId => {
    const fig = this.state.figures.find(f => f.figureId === figureId);
    const obj = {
      type: TYPE_IMAGE,
      content: fig.imageURL,
      metadata: {
        title: fig.title,
        caption: fig.caption
      }
    };
    const fn = this.figureForFront
      ? this.props.frontChange
      : this.props.backChange;
    fn(obj);
    this.closeFigures();
  };

  // timeouts address conflicts with focusing the panel header
  focusFront() {
    setTimeout(() => {
      this.front.focus();
    }, 0);
  }

  focusBack() {
    setTimeout(() => {
      this.back.focus();
    }, 0);
  }

  hasFigures() {
    return (
      BookStore.get(this.props.isbn).vbkType === "epub" &&
      this.state.figures.length > 0 &&
      areFlashcardFiguresEnabled()
    );
  }

  render() {
    let {
      back,
      backChange,
      cancel,
      errors,
      front,
      frontChange,
      onSubmit,
      swap
    } = this.props;
    return (
      <li className="card template">
        <h3 className="offScreen">
          {i18n.t("reader.flashcards.create-edit-flashcard")}
        </h3>
        <form onSubmit={onSubmit}>
          <CardInput
            error={errors && errors.front}
            label={i18n.t("reader.flashcards.front")}
            onChange={frontChange}
            cardContent={front}
            singleLine
            ref={el => (this.front = el)}
            maxLength="255"
            onOpenFigures={this.openFiguresFront}
            hasFigures={this.hasFigures()}
            addFigureLabel={i18n.t("flashcards.images.add-figure-front")}
          />
          <div className="swap-container">
            <button className="swap noButton" onClick={swap} type="button">
              <Isvg src="/img/swap.svg" />
              <span className="offScreen">
                {i18n.t("reader.flashcards.swap")}
              </span>
            </button>
          </div>
          <CardInput
            error={errors && errors.back}
            label={i18n.t("reader.flashcards.back")}
            onChange={backChange}
            cardContent={back}
            ref={el => (this.back = el)}
            maxLength="1024"
            onOpenFigures={this.openFiguresBack}
            hasFigures={this.hasFigures()}
            addFigureLabel={i18n.t("flashcards.images.add-figure-back")}
          />
          <div className="card-template-button-container">
            <Button onClick={cancel} type="button" color="neutral" naked>
              {i18n.t("base.cancel")}
            </Button>
            <Button type="submit">{i18n.t("base.save")}</Button>
          </div>
        </form>
      </li>
    );
  }
}

export default TemplatePresentation;

TemplatePresentation.defaultProps = {
  back: getEmptyCard(),
  front: getEmptyCard()
};

TemplatePresentation.propTypes = {
  back: cardContentPropTypes,
  backChange: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  errors: PropTypes.object,
  front: cardContentPropTypes,
  frontChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  swap: PropTypes.func.isRequired
};
